export const WORK = 'work' as const;
export const PLAN = 'plan' as const;
export const REPORT = 'report' as const;
